/**
 * 搜索行业
 * @docs https://yapi.baidu-int.com/project/17619/interface/api/1709373
 */
export const GET_BUYERDB_SIC_SUG_API = '/buyerdb/sic/sug';
